import React from 'react';
import {Add, Delete, EyeIcon} from "assets/icons";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import usefetchdata from "hooks/usefetchdata";
import CardProfile from "components/card/cardProfile/cardProfile";
import UseContext from "hooks/useContext";

const OtherDocuments = () => {
    const {toggle} = useModal()
    const {tempWorkerData} = usefetchdata()
    const {setObjID, setObjType} = UseContext()
    const token = localStorage.getItem('xsrfToken')

    const handleAdd = (e) => {
        e.preventDefault()
        toggle('j_c_otherDocument')
    }

    const handleDelete = (e, id) => {
        e.preventDefault()
        setObjID(id)
        setObjType('otherDocument')
        toggle('j_d_delete')
    }

    return (
        <CardProfile>
            <div className="grid grid-cols-4 flex items-center">
                <div className="col-span-3 ft-b text-gray-900">
                    Autres Documents
                </div>
                <div className='col-span-1 flex justify-end'>
                    <button
                        onClick={handleAdd}
                        className='rounded-full w-10 h-10 bg-blue-50 flex items-center justify-center'>
                        <Add wh={18} color={'#3B82F6'}/>
                    </button>
                </div>
            </div>
            <div className={'my-5'}>
                <Divider w={100}/>
            </div>
            {tempWorkerData?.otherDocuments?.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(item => (
                <React.Fragment key={item._id}>
                    <div className="grid grid-cols-2">
                        <div className="col-span-1 flex flex-col gap-1">
                            <div className="ft-sm font-medium text-gray-900">{item.documentType}</div>
                            <div className="ft-xs text-gray-500">
                                Importé le {new Date(item.createdAt).toLocaleDateString('fr-FR')} à {new Date(item.createdAt).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                            </div>
                        </div>
                        <div className="col-span-1 flex items-center justify-end gap-3">
                            <a
                                href={`${process.env.REACT_APP_INTERIM_PDF}?token=${token}&type=otherDocument&fileName=${encodeURIComponent(item.fileName)}`}
                                target={'_blank'}
                                rel="noreferrer"
                                className="rounded-full w-10 h-10 bg-gray-50 hover:bg-gray-100 flex items-center justify-center"
                            >
                                <EyeIcon wh={18} color={'#6B7280'} strokeW={2}/>
                            </a>
                            <button
                                onClick={(e) => handleDelete(e, item._id)}
                                className="rounded-full w-10 h-10 bg-red-50 hover:bg-red-100 flex items-center justify-center"
                            >
                                <Delete color={'#EF4444'} wh={18}/>
                            </button>
                        </div>
                    </div>
                    <div className={'my-5'}>
                        <Divider w={100}/>
                    </div>
                </React.Fragment>
            ))}
        </CardProfile>
    );
};

export default OtherDocuments;
